import { useCallback, useEffect, useState } from "react";
import api from "api/api";

//Material UI Components

import { CircularProgress } from "@mui/material";

//import assets
import brandImg from "../../assets/brands.png";
import countryImg from "../../assets/country.jpeg";
import competitorImg from "../../assets/competitor.png";
import studyRefImg from "../../assets/study-ref.jpeg";
import interviewRespondents from "../../assets/Interview-respondants.png";

// import helper

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";
const summaryLabel = [
    {
        title: "Studies",
        image: studyRefImg,
        value: "studies",
    },
    {
        title: "Unilever Products",
        image: brandImg,
        value: "unileverProduct",
    },
    {
        title: "Benchmark Products",
        image: competitorImg,
        value: "competitorProduct",
    },
    {
        title: "Countries",
        image: countryImg,
        value: "countries",
    },
    {
        title: "Respondents",
        image: interviewRespondents,
        value: "respondents",
    },
];

function StudySelectionSummary() {
    const dispatch = useDispatch();

    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const coreDataIds = selectedStudy.map((ele) => ele.id)?.join(",");
    const [data, setData] = useState({
        studies: 0,
        unileverProduct: 0,
        competitorProduct: 0,
        countries: 0,
        respondents: 0,
    });
    const [progress, setProgress] = useState(false);
    const updateSummary = useCallback((res, selectedStudy) => {
        const ulProCount = selectedStudy
            .map((ele) => {
                return ele.products.length;
            })
            .reduce((a, b) => {
                return a + b;
            });
        const comProCount = selectedStudy
            .map((ele) => {
                return ele.competitor_products.length;
            })
            .reduce((a, b) => {
                return a + b;
            });

        setData((prevState) => ({
            ...prevState,
            studies: selectedStudy.length,
            countries: res.data.country_of_respondent.length,
            unileverProduct: ulProCount,
            competitorProduct: comProCount,
            respondents: res.data.number_of_respondents,
        }));
    }, []);

    useEffect(() => {
        coreDataIds.length > 0 && setProgress(true);
        const fetchData = setTimeout(async () => {
            if (coreDataIds.length > 0) {
                try {
                    const url = process.env.REACT_APP_SERVER_PATH + `/study-datas/study-count/?archive=false&return_respondent=true&core_data_model_id=${coreDataIds}`;
                    await api
                        .get(url)
                        .then(async (res) => {
                            updateSummary(res, selectedStudy);
                            setProgress(false);
                        })
                        .catch((error) => {
                            handleError(error);
                            setProgress(false);
                        });
                } catch (error) {
                    handleError(error);
                    setProgress(false);
                }
            } else {
                setData({
                    studies: 0,
                    unileverProduct: 0,
                    competitorProduct: 0,
                    countries: 0,
                    respondents: 0,
                });
            }
        }, 1000);
        return () => {
            clearTimeout(fetchData);
            setProgress(false);
        };
    }, [coreDataIds, selectedStudy, updateSummary]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        <>
            {summaryLabel &&
                summaryLabel.map((ele) => {
                    return (
                        <div
                            key={ele.value}
                            className="remove-opacity box-shadow--full-container"
                            style={{
                                backgroundColor: "#FFFFFF",
                                padding: "5px",
                                color: "#005eef",
                                borderRadius: "5px",
                                fontSize: "10px",
                                fontWeight: "600",
                                marginTop: "10px",
                                marginBottom: "20px",
                            }}
                        >
                            <div className={"filter-img-box "}>
                                <img
                                    src={ele.image}
                                    alt={ele.value}
                                    style={{
                                        width: "125px",
                                        height: "70px",
                                        marginBottom: 5,
                                    }}
                                />
                            </div>
                            <span
                                style={{
                                    textShadow: "rgb(255, 255, 255) 0px 0px 10px, rgba(255, 71, 217, 0) 11px -1px 12px",
                                }}
                            >
                                <span>{ele.title}</span>
                                <span
                                    style={{
                                        position: "absolute",
                                        right: "5px",
                                    }}
                                >
                                    {progress ? (
                                        <CircularProgress
                                            sx={{ color: "#005EEF", marginRight: "5px" }}
                                            size={12}
                                        />
                                    ) : (
                                        data[ele.value]
                                    )}
                                </span>
                            </span>
                        </div>
                    );
                })}
        </>
    );
}

export default StudySelectionSummary;
